<template>
  <div class="flex items-center">
    <p :class="displayClasses" style="height: 30px; width: 30px; text-shadow: 1px 1px 3px #999"
      :title="titleText">{{ displayValue }}</p>
  </div>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

const YES = "shadow text-center px-2 bg-gradient-to-br from-green-300 to-green-400 rounded-full text-white flex items-center text-sm";
const NO = "shadow text-center px-2 bg-gradient-to-br from-gray-200 to-gray-300 rounded-full text-gray-500 flex items-center text-sm";

export default defineComponent({
  name: "TickValue",
  computed: {
    isYes() {
      return !!this.params.value;
    },
    displayValue() {
      return this.isYes ? "✓" : "–";
    },
    displayClasses() {
      return this.isYes ? YES : NO;
    },
    titleText() {
      return this.isYes ? "Yes" : "No";
    },
  },
});
</script>
